import React, { useCallback, useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import * as yup from 'yup';

import { AccordionListItem } from 'components/Button';
import useYupValidationResolver from 'hook/useYupValidationResolver';
import { Modal } from 'components/Modal';
import { Button, Stack } from '@mui/material';
import { FormProvider, TextField } from 'components/Form';
import { useUpdateCompanyById } from '../api/updateCompanyById';

const companyValidationSchema = yup.object({
  Name: yup.string().required('Company name is required'),
});


const getDefaultValues = () => ({
  Name: '',
});

export const EditCompanyModal = ({company, refetch}) => {
  const { id: companyId } = useParams();
  const [open, setOpen] = useState(false);

  const methods = useForm({
    defaultValues: getDefaultValues(),
    resolver: useYupValidationResolver(companyValidationSchema),
  });

  const { mutateAsync } = useUpdateCompanyById(companyId, refetch);

  const handleClose = useCallback(() => setOpen(false), []);
  const handleOpen = useCallback(() => setOpen(true), []);

  const onMutation = useCallback(() => {
    refetch();
    handleClose();
  }, []);
  const onSubmit = (values) => {
    mutateAsync(values)
      .then(onMutation)
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    if (!open) {
      methods.reset({ ...company });
    } else if (open) {
      const {
        Name,
      } = company;

      methods.reset({
        Name,
      });
    }
  }, [open]);

  return (
    <>
      <AccordionListItem onClick={handleOpen}>Edit name</AccordionListItem>
      <Modal title="Edit company" handleClose={handleClose} open={open}>
        <FormProvider methods={methods} onSubmit={onSubmit}>
          <Stack gap={3} mb={3}>
            <TextField required fullWidth name="Name" label="Company Name" />
          </Stack>

          <Stack direction="row" gap={3} justifyContent="center">
            <Button variant="outlined" color="primary" onClick={handleClose}>
              Cancel
            </Button>
            <Button variant="contained" color="primary" type="submit">
              Update
            </Button>
          </Stack>
        </FormProvider>
      </Modal>
    </>
  );
};
